import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import IconContainer from './IconContainer'
import IconLabel from './IconLabel'

const ErrorIcon = ({ label }) => {
    return (
        <Box display="flex" alignItems="center">
            <IconContainer bgcolor="#dc3131">
                <Icon name="Exclamation" color="#ffffff" />
            </IconContainer>
            <IconLabel style={{ color: '#dc3131' }}>{label}</IconLabel>
        </Box>
    )
}

export default ErrorIcon
